//
// locales/vanilla/te.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/te.json';
import localeData from 'react-intl/locale-data/te.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
